'use client'; // Error components must be Client Components

import { type ReactNode, useEffect } from 'react';

import PageErrorComponent from '@/components/common/errors/error-component';

// eslint-disable-next-line sonarjs/function-return-type
export default function HomeErrorComponent({
  error,
  reset,
}: Readonly<{
  error: Error & { digest?: string };
  reset: () => void;
}>): ReactNode {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('[HomePageErrorComponent]', error);
  }, [error]);

  return (
    <PageErrorComponent
      error={error}
      reset={reset}
      title={'Error in Landing Page'}
    />
  );
}
